import React, { useMemo, useState } from "react";
import { Coins, Search } from "lucide-react";
import { GptAnswer } from "./GptAnswer";
import { useGptJob } from "./useGptJob";
import { PickCard } from "./PickCard";
import { useDualScores } from "./useDualScores";

const JSON_BLOCK = /```json\s*([\s\S]*?)```\s*$/;

const parsePicks = (reply) => {
  const m = reply && reply.match(JSON_BLOCK);
  if (!m) return { picks: [], text: reply };
  try {
    const picks = JSON.parse(m[1]).filter((p) => p && p.ticker);
    return { picks, text: reply.replace(JSON_BLOCK, "").trim() };
  } catch (e) {
    return { picks: [], text: reply };
  }
};

export const CashDeploy = ({ owner }) => {
  const [cash, setCash] = useState("");
  const [gpt, runGpt] = useGptJob(owner);
  const amount = parseFloat(cash) || 0;
  const { picks, text } = useMemo(() => parsePicks(gpt?.reply), [gpt?.reply]);
  const { scores, pending } = useDualScores(picks.map((p) => p.ticker));

  return (
    <div className="bg-slate-800/50 border border-emerald-500/30 rounded-lg p-4" data-testid="pe-deploy">
      <div className="font-semibold text-slate-100 mb-1 flex items-center gap-2">
        <Coins className="w-5 h-5 text-emerald-400" /> Investir mon cash
      </div>
      <div className="text-xs text-slate-400 mb-3">
        Indique ton cash disponible : GPT choisit 3 à 5 actions de qualité qui diversifient ton portefeuille hors IA/semis. Chaque action reçoit un score Growth (G, potentiel 5-10 ans) et un score Investissement (I, attractivité au prix actuel).
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <div className="relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm">€</span>
          <input type="number" min="0" value={cash} onChange={(e) => setCash(e.target.value)} placeholder="ex : 40000"
            className="bg-slate-900 border border-slate-700 focus:border-emerald-500 outline-none rounded-lg pl-7 pr-3 py-2 text-sm w-48"
            data-testid="pe-deploy-cash-input" />
        </div>
        <button onClick={() => runGpt({ mode: "deploy", cash_eur: amount })} disabled={!amount || gpt?.loading}
          className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-500 disabled:bg-slate-700 text-white rounded-full px-4 py-2 text-sm font-semibold transition-colors"
          data-testid="pe-deploy-run-btn">
          <Search className="w-4 h-4" /> Trouver des actions à acheter
        </button>
      </div>
      {picks.length > 0 && (
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3" data-testid="pe-deploy-picks">
          {picks.map((p) => <PickCard key={p.ticker} p={p} score={scores[p.ticker]} loading={pending.includes(p.ticker)} />)}
        </div>
      )}
      <GptAnswer state={gpt?.reply ? { reply: text } : gpt} testid="pe-deploy-gpt" />
    </div>
  );
};
